<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { request } from '../services/api'

const route = useRoute()
const records = ref([])
const loading = ref(true)
const loadingMore = ref(false)
const pageInfo = ref(null)
const errorMessage = ref('')
const hasMore = computed(() => pageInfo.value && Number(pageInfo.value.page_index || 1) < Number(pageInfo.value.page_count || 1))
function formatTime(value) {
  if (!value) return '-'
  const d = new Date(typeof value === 'number' || /^\d+$/.test(value) ? Number(value) * 1000 : value)
  return Number.isNaN(d.getTime()) ? String(value) : d.toLocaleString('zh-CN', { hour12: false })
}
function resultNumbers(record) {
  const value = String(record.history_lottery_numbers || record.lottery_numbers || '').trim()
  return value ? value.split(/[\s,|+，]+/).filter(Boolean).slice(0, 10) : ['-']
}
async function loadRecords(page = 1) {
  const firstPage = page === 1
  if (firstPage) loading.value = true
  else loadingMore.value = true
  errorMessage.value = ''
  try {
    const result = await request('/game/history', { data: { game: route.params.game, page } })
    const nextRecords = result.data?.lists || result.data || []
    records.value = firstPage ? nextRecords : [...records.value, ...nextRecords]
    pageInfo.value = result.page || null
  } catch (error) {
    errorMessage.value = error.message || '开奖历史加载失败。'
  } finally {
    loading.value = false
    loadingMore.value = false
  }
}
onMounted(() => loadRecords())
watch(() => route.params.game, () => loadRecords())
</script>

<template>
  <main class="history-page">
    <header class="topbar"><RouterLink :to="`/game/${route.params.game}`" class="back">‹</RouterLink><span>开奖历史</span><RouterLink to="/user/finance">账务</RouterLink></header>
    <p v-if="errorMessage" class="state error">{{ errorMessage }}</p>
    <p v-else-if="loading" class="state">正在加载开奖历史…</p>
    <p v-else-if="!records.length" class="state">暂无开奖记录。</p>
    <section v-else class="history-list">
      <article v-for="record in records" :key="record.history_id || record.game_no" class="history-item"><div><b>第 {{ record.game_no }} 期</b><small>{{ formatTime(record.history_lottery_time || record.history_open_time) }}</small></div><aside class="number-balls"><span v-for="(number, index) in resultNumbers(record)" :key="`${record.game_no}-${index}`">{{ number }}</span></aside></article>
      <button v-if="hasMore" class="load-more" :disabled="loadingMore" @click="loadRecords(Number(pageInfo?.page_index || 1) + 1)">{{ loadingMore ? '正在加载…' : '加载更多记录' }}</button>
    </section>
  </main>
</template>

<style scoped>
.history-page{min-height:100vh;background:#f5f5f5}.topbar{display:flex;height:56px;align-items:center;justify-content:space-between;padding:0 16px;background:var(--ion-color-primary);color:#fff;font-size:17px}.topbar a{color:#fff;font-size:14px;text-decoration:none}.topbar .back{font-size:33px;font-weight:200;line-height:1}.history-list{margin-top:10px;background:#fff}.history-item{display:flex;min-height:67px;align-items:center;justify-content:space-between;gap:12px;padding:0 15px;border-bottom:1px solid #edf0f4}.history-item div{display:grid;gap:5px}.history-item b{color:#37465d;font-size:14px;font-weight:500}.history-item small{color:#96a2b2;font-size:11px}.number-balls{display:flex;max-width:52%;flex-wrap:wrap;justify-content:flex-end;gap:4px}.number-balls span{display:grid;min-width:23px;height:23px;place-items:center;border-radius:50%;padding:0 4px;background:linear-gradient(145deg,var(--ion-color-primary-tint),var(--ion-color-primary));color:#fff;font-size:11px;font-weight:600;box-shadow:0 1px 2px rgb(20 76 158 / 22%)}.state{margin:30px 15px;color:#8a98aa;text-align:center;font-size:14px}.error{color:#d14343}.load-more{display:block;width:calc(100% - 30px);height:38px;margin:12px 15px;border:1px solid #cbd9ec;border-radius:5px;background:#fff;color:var(--ion-color-primary);font-size:13px}.load-more:disabled{opacity:.6}
</style>
